import { jsx as a, jsxs as h } from "react/jsx-runtime";
const t = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M12 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2m10.67 1.47-8.05-14a3 3 0 0 0-5.24 0l-8 14A3 3 0 0 0 3.94 22h16.12a3 3 0 0 0 2.61-4.53m-1.73 2a1 1 0 0 1-.88.51H3.94a1 1 0 0 1-.88-.51 1 1 0 0 1 0-1l8-14a1 1 0 0 1 1.78 0l8.05 14a1 1 0 0 1 .05 1.02zM12 8a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1" })
  }
), n = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ a("path", { d: "M10 14c.345 0 .68.044 1 .126v1.228a4.012 4.012 0 0 0-.465.646H9v-1.874A4.01 4.01 0 0 1 10 14" }),
      /* @__PURE__ */ a("path", { d: "M11 15.354V16h-.465c.134-.23.29-.447.465-.646M13 16h2v-4h-2v3.354z" }),
      /* @__PURE__ */ a(
        "path",
        {
          fillRule: "evenodd",
          d: "M8 18a2 2 0 0 1 2-2H9v-1.874a4.002 4.002 0 1 0 3 7.339 4 4 0 1 0 1-7.339v1.228c.175.199.331.415.465.646H14a2 2 0 1 1-2 2 2 2 0 0 1-4 0m1-3.874a4.01 4.01 0 0 1 2 0V12H9z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a("path", { d: "M13 8h2v4h-2V8.646z" }),
      /* @__PURE__ */ a(
        "path",
        {
          fillRule: "evenodd",
          d: "M9 9.874V12h2V9.874a4.007 4.007 0 0 1-2 0M14 10c.345 0 .68-.044 1-.126V8H13.465c-.134.23-.29.447-.465.646v1.228c.32.082.655.126 1 .126",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a("path", { d: "M11 8.646V8h-.465c.134.23.29.447.465.646" }),
      /* @__PURE__ */ a("path", { d: "M10 8a2 2 0 1 1 2-2 2 2 0 1 1 2 2h1v1.874a4.002 4.002 0 1 0-3-7.339 4 4 0 1 0-3 7.339V8z" }),
      /* @__PURE__ */ a("path", { d: "M10 10c.345 0 .68-.044 1-.126V8.646A4.014 4.014 0 0 1 10.535 8H9v1.874c.32.082.655.126 1 .126" })
    ]
  }
), c = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "m14.72 8.79-4.29 4.3-1.65-1.65a1 1 0 1 0-1.41 1.41l2.35 2.36a1 1 0 0 0 1.41 0l5-5a1.002 1.002 0 1 0-1.41-1.42M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20" })
  }
), i = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M18.71 7.21a1.001 1.001 0 0 0-1.42 0l-7.45 7.46-3.13-3.14a1.024 1.024 0 0 0-1.445.025A1.022 1.022 0 0 0 5.29 13l3.84 3.84a1.001 1.001 0 0 0 1.42 0l8.16-8.16a1 1 0 0 0 0-1.47" })
  }
), e = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M17 11H9.41l3.3-3.29a1.004 1.004 0 1 0-1.42-1.42l-5 5a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l5 5a1.002 1.002 0 0 0 1.639-.325 1.002 1.002 0 0 0-.219-1.095L9.41 13H17a1 1 0 0 0 0-2" })
  }
), r = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M17.92 11.62a1.001 1.001 0 0 0-.21-.33l-5-5a1.003 1.003 0 1 0-1.42 1.42l3.3 3.29H7a1 1 0 0 0 0 2h7.59l-3.3 3.29a1.002 1.002 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l5-5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76" })
  }
), v = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M10 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4.5 4.06a1 1 0 0 0-1.37.36 1.3 1.3 0 0 1-2.26 0 1 1 0 0 0-1.37-.36 1 1 0 0 0-.37 1.36 3.31 3.31 0 0 0 5.74 0 1 1 0 0 0-.37-1.36M15 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3-7a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18A8 8 0 0 1 9 4.57c-.01.143-.01.287 0 .43a3 3 0 0 0 3 3 1 1 0 1 0 0-2 1 1 0 1 1 0-2 8 8 0 0 1 0 16" })
  }
), w = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          d: "M9.181 3.62a.855.855 0 0 1 .99-.603l2.374.475a.855.855 0 1 1-.335 1.676l-1.602-.32-.53 1.856h1.23a.95.95 0 0 1 .943 1.062L12 11a6.602 6.602 0 0 0-1.797.639l.25-3.225H4.804l1.176 9.876h2.83l.088.27c.165.514.32.997.63 1.44H5.306a.95.95 0 0 1-.944-.838L3.007 7.766a.95.95 0 0 1 .943-1.062H8.3z"
        }
      ),
      /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.673 15.251c0-3.17 2.8-5.603 6.079-5.603 3.278 0 6.077 2.434 6.077 5.603a.855.855 0 0 1-.854.855H9.528a.855.855 0 0 1-.855-.855m10.34-.855c-.432-1.695-2.12-3.039-4.262-3.039-2.141 0-3.829 1.344-4.26 3.04z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          d: "M9.433 16.391a.855.855 0 0 0 0 1.71H20.07a.855.855 0 1 0 0-1.71zM8.579 19.145c0-.472.382-.854.854-.854H20.07a.855.855 0 1 1 0 1.709H9.433a.855.855 0 0 1-.854-.855"
        }
      )
    ]
  }
), s = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M3 8h18a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2m18 8H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m0-5H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2" })
  }
), g = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M12 2a10 10 0 0 0-8.4 4.59 10 10 0 0 0 14.66 13.2A10 10 0 0 0 12 2m2 2.26A8 8 0 0 1 19.74 10 9.78 9.78 0 0 0 15 11.38a15.7 15.7 0 0 0-2.4-2.21A10.06 10.06 0 0 0 14 4.26M12 4a7.9 7.9 0 0 1-1.14 4.07c-.15-.08-.29-.17-.44-.24a15.52 15.52 0 0 0-4.09-1.47A8 8 0 0 1 12 4M5 8.16A13.75 13.75 0 0 1 9.49 9.6l.13.08A7.93 7.93 0 0 1 4 12a8 8 0 0 1 1-3.84m5 11.58A8 8 0 0 1 4.26 14a9.9 9.9 0 0 0 7.08-3.21 14 14 0 0 1 2 1.8A10 10 0 0 0 10 19.74m2 .26a8.002 8.002 0 0 1 2.56-5.85c.06.08.12.15.17.23a14 14 0 0 1 1.84 4.18A7.93 7.93 0 0 1 12 20m6.21-3a16.001 16.001 0 0 0-1.8-3.75L16.2 13a7.93 7.93 0 0 1 3.8-1 8 8 0 0 1-1.79 5" })
  }
), d = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M3.62 17.28a1 1 0 1 0 1.86-.74l-1.12-2.82L11 12.25V17a1 1 0 0 0 2 0v-4.75l6.64 1.47-1.12 2.82a1 1 0 1 0 1.86.74l1.55-3.91a1 1 0 0 0-.05-.84 1 1 0 0 0-.66-.51L18 11.31V7a1 1 0 0 0-1-1h-2V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3H7a1 1 0 0 0-1 1v4.31L2.78 12a1 1 0 0 0-.66.51 1 1 0 0 0-.05.84zM11 4h2v2h-2zM8 8h8v2.86L12.22 10H11.78L8 10.86zm12.71 11.28c-.35.107-.687.259-1 .45a2.08 2.08 0 0 1-2.1 0 4.62 4.62 0 0 0-4.54 0 2.14 2.14 0 0 1-2.12 0 4.64 4.64 0 0 0-4.54 0 2.08 2.08 0 0 1-2.1 0 4.38 4.38 0 0 0-1-.45A1 1 0 0 0 2 20a1 1 0 0 0 .67 1.24 2.1 2.1 0 0 1 .57.25 4 4 0 0 0 2 .55 4.14 4.14 0 0 0 2.08-.56 2.65 2.65 0 0 1 2.56 0 4.15 4.15 0 0 0 4.12 0 2.65 2.65 0 0 1 2.56 0 4 4 0 0 0 4.1 0c.177-.111.369-.195.57-.25A1.002 1.002 0 0 0 22 20a.998.998 0 0 0-1.29-.72" })
  }
), p = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M14 8h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2m0 4h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2M9 8h1a1 1 0 1 0 0-2H9a1 1 0 0 0 0 2m0 4h1a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2m12 8h-1V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v17H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m-8 0h-2v-4h2zm5 0h-3v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5H6V4h12z" })
  }
), m = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fillRule: "evenodd",
        d: "M11.417 2.354a1.832 1.832 0 0 1 2.166 0l5.41 3.982h.062v.046l1.558 1.147a.829.829 0 0 1 .171 1.175.866.866 0 0 1-1.197.168l-.532-.392v11.842h2.09c.472 0 .855.375.855.839 0 .463-.383.839-.855.839H3.855A.847.847 0 0 1 3 21.16c0-.463.383-.838.855-.838h2.09V8.48l-.532.392a.866.866 0 0 1-1.197-.168.829.829 0 0 1 .171-1.175l1.558-1.147v-.046h.063zM7.655 20.322h1.14v-.187h-1.14zm0-1.865v-1.119h1.14v1.119zm1.14-2.797v-1.12h-1.14v1.12zm-1.14-2.797v-1.12h1.14v1.12zm1.14-2.798a.87.87 0 0 1 .248.036 1.81 1.81 0 0 1 1.557-.875h3.8a1.81 1.81 0 0 1 1.557.875.87.87 0 0 1 .248-.036h1.14V8.947h-9.69v1.118zm7.41 2.798v-1.12h1.14v1.12zm0 1.678v1.119h1.14v-1.12zm0 3.916v-1.119h1.14v1.119zm0 1.678v.187h1.14v-.187zM7.655 7.268h9.69v-.047l-1.554-1.143a.866.866 0 0 1-.346.071h-5.89a.866.866 0 0 1-.346-.071L7.655 7.22zm3.736-2.797h2.218l-1.052-.774a.096.096 0 0 0-.114 0zm3.104 15.85v-9.323a.094.094 0 0 0-.095-.093h-3.8a.094.094 0 0 0-.095.093v9.324z",
        clipRule: "evenodd"
      }
    )
  }
), f = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M12 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-5 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7-12h-1V2a1 1 0 0 0-2 0v1H8V2a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9h16zm0-11H4V6a1 1 0 0 1 1-1h1v1a1 1 0 0 0 2 0V5h8v1a1 1 0 0 0 2 0V5h1a1 1 0 0 1 1 1zM7 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2" })
  }
), M = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M19.44 13c-.22 0-.45-.07-.67-.12a9.443 9.443 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.45a12.18 12.18 0 0 1-2.66-2 12.18 12.18 0 0 1-2-2.66l.42-.28a2 2 0 0 0 1-2.48 10.32 10.32 0 0 1-.39-1.31c-.05-.22-.09-.45-.12-.68a3 3 0 0 0-3-2.49h-3a3 3 0 0 0-3 3.41 19 19 0 0 0 16.52 16.46h.38a3 3 0 0 0 2.741-1.778 3 3 0 0 0 .259-1.232v-3a3 3 0 0 0-2.47-2.9m.5 6a1 1 0 0 1-.723.962 1.05 1.05 0 0 1-.437.038A17 17 0 0 1 4.07 5.22a1.09 1.09 0 0 1 .25-.82 1 1 0 0 1 .75-.34h3a1 1 0 0 1 1 .79c.04.273.09.543.15.81.116.527.27 1.045.46 1.55l-1.4.65a1 1 0 0 0-.49 1.33 14.49 14.49 0 0 0 7 7 1 1 0 0 0 .76 0 1.002 1.002 0 0 0 .57-.52l.62-1.4c.517.185 1.045.338 1.58.46.267.06.537.11.81.15a1 1 0 0 1 .79 1z" })
  }
), x = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M21.12 16.88a3 3 0 0 0-3.4-.58l-1.15-1.14a23.999 23.999 0 0 0 5.21-8.86 3.19 3.19 0 0 0-4.08-4.08 24 24 0 0 0-8.86 5.21L7.7 6.28a3 3 0 1 0-4.82.84A3 3 0 0 0 5 8a3 3 0 0 0 1.28-.3l1.15 1.14a24 24 0 0 0-5.21 8.86A3.24 3.24 0 0 0 3 21a3.17 3.17 0 0 0 2.22 1 3.74 3.74 0 0 0 1.08-.17 24 24 0 0 0 8.86-5.21l1.14 1.15a3 3 0 1 0 4.82-.84zM5.71 5.7a1 1 0 1 1-1.42-1.41A1 1 0 0 1 5.71 5.7m12.6-1.57a1.6 1.6 0 0 1 .47-.08 1.16 1.16 0 0 1 .83.34 1.23 1.23 0 0 1 .26 1.3 22.089 22.089 0 0 1-2.13 4.64l-4.07-4.07a22.091 22.091 0 0 1 4.64-2.13M5.69 19.87a1.2 1.2 0 0 1-1.56-1.56 22.089 22.089 0 0 1 2.13-4.64l4.07 4.07a22.093 22.093 0 0 1-4.64 2.13M12 16.59 7.41 12a21.3 21.3 0 0 1 1.43-1.74l4.91 4.91c-.558.504-1.142.978-1.75 1.42m3.15-2.84-4.9-4.91A21.297 21.297 0 0 1 12 7.41l4.6 4.6c-.449.605-.93 1.186-1.44 1.74zm4.55 6a1.001 1.001 0 0 1-1.42-1.41 1 1 0 0 1 1.41 0 1 1 0 0 1 .02 1.37z" })
  }
), I = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 13a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM10.5 14a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1M15.5 13a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2z"
        }
      ),
      /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          d: "M12 2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2H5.766a2 2 0 0 0-1.985 1.752l-.55 4.401A2 2 0 0 0 2 18v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a2 2 0 0 0-1.23-1.847l-.551-4.401A2 2 0 0 0 18.234 10H16V8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm6 2v2h-6V4zM4 18h16v2H4zm1.266-2 .5-4h12.468l.5 4z"
        }
      )
    ]
  }
), z = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M12 9a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m7-7H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zM12 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" })
  }
), u = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M17 9.17a1 1 0 0 0-1.41 0L12 12.71 8.46 9.17a1 1 0 1 0-1.41 1.42l4.24 4.24a1.002 1.002 0 0 0 1.42 0L17 10.59a1.002 1.002 0 0 0 0-1.42" })
  }
), A = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "m11.29 12 3.54-3.54a1 1 0 1 0-1.42-1.41l-4.24 4.24a1.001 1.001 0 0 0 0 1.42L13.41 17a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41z" })
  }
), C = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "m14.83 11.29-4.24-4.24a1 1 0 1 0-1.42 1.41L12.71 12l-3.54 3.54a1 1 0 0 0 0 1.41 1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l4.24-4.24a1.002 1.002 0 0 0 0-1.42" })
  }
), H = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "m13.41 12 6.3-6.29a1.004 1.004 0 1 0-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 0 0-1.42 1.42l6.3 6.29-6.3 6.29a1 1 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l6.29-6.3 6.29 6.3a1.002 1.002 0 0 0 1.639-.325 1 1 0 0 0-.219-1.095z" })
  }
), S = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M7 15h3a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2M19 5H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3m1 12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6h16zm0-8H4V8a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z" })
  }
), V = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M5 18h4.24a.999.999 0 0 0 .71-.29l6.92-6.93L19.71 8a1.001 1.001 0 0 0 0-1.42l-4.24-4.29a1 1 0 0 0-1.42 0l-2.82 2.83-6.94 6.93a1.001 1.001 0 0 0-.29.71V17a1 1 0 0 0 1 1m9.76-13.59 2.83 2.83-1.42 1.42-2.83-2.83zM6 13.17l5.93-5.93 2.83 2.83L8.83 16H6zM21 20H3a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2" })
  }
), B = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22m0 20a9 9 0 1 1 0-18 9 9 0 0 1 0 18m.59-13.33a3.34 3.34 0 0 1 2.62 1.38 1 1 0 0 0 1.659-.105 1 1 0 0 0-.079-1.115 5.32 5.32 0 0 0-4.2-2.16A5.57 5.57 0 0 0 7.46 9.5H6a1 1 0 0 0 0 2h1v1H6a1 1 0 0 0 0 2h1.46a5.57 5.57 0 0 0 5.13 3.83 5.32 5.32 0 0 0 4.2-2.16A1 1 0 1 0 15.21 15a3.34 3.34 0 0 1-2.62 1.38 3.42 3.42 0 0 1-2.92-1.88H12a1 1 0 0 0 0-2H9.05A4.233 4.233 0 0 1 9 12c.007-.168.023-.335.05-.5H12a1 1 0 0 0 0-2H9.67a3.42 3.42 0 0 1 2.92-1.83"
      }
    )
  }
), L = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M18 10.82a1 1 0 0 0-1 1V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h7.18a1 1 0 1 0 0-2H5a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-7.18a1 1 0 0 0-1-1m3.92-8.2a1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-6a1 1 0 1 0 0 2h3.59L8.29 14.29a1 1 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219L20 5.41V9a1 1 0 0 0 2 0V3a1.001 1.001 0 0 0-.08-.38" })
  }
), P = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M21.92 11.6C19.9 6.91 16.1 4 12 4s-7.9 2.91-9.92 7.6a1 1 0 0 0 0 .8C4.1 17.09 7.9 20 12 20s7.9-2.91 9.92-7.6a1 1 0 0 0 0-.8M12 18c-3.18 0-6.17-2.29-7.9-6C5.83 8.29 8.82 6 12 6c3.18 0 6.17 2.29 7.9 6-1.73 3.71-4.72 6-7.9 6m0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4" })
  }
), k = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M15.12 5.32H17V2.14A26.113 26.113 0 0 0 14.26 2c-2.72 0-4.58 1.66-4.58 4.7v2.62H6.61v3.56h3.07V22h3.68v-9.12h3.06l.46-3.56h-3.52V7.05c0-1.05.28-1.73 1.76-1.73" })
  }
), b = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ...l,
    children: [
      /* @__PURE__ */ a("g", { clipPath: "url(#a)", children: /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M30 8.333a2.333 2.333 0 0 0 4.667 0v-6a2.333 2.333 0 0 0-4.667 0zm21.683 3.593a2.333 2.333 0 1 0 3.3 3.3l4.243-4.243a2.333 2.333 0 0 0-3.3-3.3zm-15.16 1.951a18.764 18.764 0 0 1 7.356 3.65v-.046a18.354 18.354 0 0 1 6.693 12.362 18.256 18.256 0 0 1-4.056 13.43 11.817 11.817 0 0 0-2.847 7.347v6.471c0 1.833-.737 3.59-2.05 4.886A7.048 7.048 0 0 1 36.669 64h-9.334a7.048 7.048 0 0 1-4.95-2.023 6.863 6.863 0 0 1-2.051-4.886v-6.908a10.38 10.38 0 0 0-2.66-6.61 18.497 18.497 0 0 1-3.74-7.214 18.347 18.347 0 0 1-.274-8.1 18.347 18.347 0 0 1 5.075-9.471 18.745 18.745 0 0 1 9.556-5.083 18.911 18.911 0 0 1 8.232.172M38.32 58.72a2.288 2.288 0 0 0 .683-1.629v-2.303H25.001v2.303c0 .611.246 1.197.683 1.629a2.35 2.35 0 0 0 1.65.674h9.335a2.35 2.35 0 0 0 1.65-.674m.683-8.537a16.3 16.3 0 0 1 3.897-9.765 13.454 13.454 0 0 0 3.104-8.658 13.666 13.666 0 0 0-1.352-5.932 13.846 13.846 0 0 0-3.8-4.784 14.074 14.074 0 0 0-5.514-2.712 14.182 14.182 0 0 0-6.159-.114 14.075 14.075 0 0 0-6.39 3.14 13.81 13.81 0 0 0-3.992 5.84 13.646 13.646 0 0 0-.555 7.024 13.737 13.737 0 0 0 3.026 6.38 14.857 14.857 0 0 1 3.734 9.58h4.667v-6.908c0-.61.246-1.197.684-1.629a2.35 2.35 0 0 1 1.65-.674 2.35 2.35 0 0 1 1.65.675c.437.431.683 1.017.683 1.628v6.909zM8.333 32.667a2.333 2.333 0 0 0 0-4.667h-6a2.333 2.333 0 0 0 0 4.667zM64 30.333a2.333 2.333 0 0 1-2.333 2.334h-6a2.333 2.333 0 0 1 0-4.667h6A2.333 2.333 0 0 1 64 30.333m-12.317 16.65a2.333 2.333 0 0 0 0 3.3l4.243 4.243a2.333 2.333 0 0 0 3.3-3.3l-4.243-4.243a2.333 2.333 0 0 0-3.3 0M14.526 11.926a2.333 2.333 0 1 1-3.3 3.3l-4.243-4.243a2.333 2.333 0 0 1 3.3-3.3zm0 35.057a2.333 2.333 0 0 1 0 3.3l-4.243 4.243a2.333 2.333 0 0 1-3.3-3.3l4.243-4.243a2.333 2.333 0 0 1 3.3 0",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h64v64H0z" }) }) })
    ]
  }
), R = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M11.29 15.29a1.573 1.573 0 0 0-.12.15.762.762 0 0 0-.09.18.643.643 0 0 0-.06.18 1.362 1.362 0 0 0 0 .2.84.84 0 0 0 .08.38.9.9 0 0 0 .54.54.94.94 0 0 0 .76 0 .9.9 0 0 0 .54-.54A1 1 0 0 0 13 16a1 1 0 0 0-1.71-.71M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20m0-13a3 3 0 0 0-2.6 1.5 1 1 0 1 0 1.73 1A1 1 0 0 1 12 9a1 1 0 1 1 0 2 1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-.18A3 3 0 0 0 12 7" })
  }
), F = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ...l,
    children: [
      /* @__PURE__ */ a("g", { clipPath: "url(#a)", children: /* @__PURE__ */ a("g", { clipPath: "url(#b)", children: /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          d: "M51.976 21.157a21.832 21.832 0 0 0-9.314-10.372 21.575 21.575 0 0 0-13.644-2.57A21.659 21.659 0 0 0 16.616 14.5a21.962 21.962 0 0 0-6.095 12.57 12.41 12.41 0 0 0-7.293 5.013 12.587 12.587 0 0 0-2.14 8.632 12.542 12.542 0 0 0 4.093 7.884 12.356 12.356 0 0 0 8.257 3.147 3.09 3.09 0 0 0 2.194-.916 3.14 3.14 0 0 0 .909-2.212 3.14 3.14 0 0 0-.909-2.211 3.09 3.09 0 0 0-2.194-.916 6.18 6.18 0 0 1-4.388-1.833 6.28 6.28 0 0 1-1.818-4.423 6.28 6.28 0 0 1 1.818-4.423 6.18 6.18 0 0 1 4.388-1.832 3.09 3.09 0 0 0 2.194-.916 3.14 3.14 0 0 0 .909-2.211 15.712 15.712 0 0 1 3.693-10.094 15.486 15.486 0 0 1 9.289-5.3c3.62-.605 7.336.105 10.487 2.001a15.614 15.614 0 0 1 6.723 8.357 3.13 3.13 0 0 0 .922 1.386c.426.369.944.614 1.498.71a9.293 9.293 0 0 1 5.315 3.085 9.424 9.424 0 0 1 2.257 5.749 9.436 9.436 0 0 1-1.781 5.916 9.308 9.308 0 0 1-5.047 3.515 3.111 3.111 0 0 0-1.9 1.441 3.154 3.154 0 0 0-.334 2.374 3.13 3.13 0 0 0 1.43 1.917c.71.422 1.558.543 2.356.335 3.265-.87 6.16-2.79 8.245-5.468a15.716 15.716 0 0 0 3.304-9.374 15.723 15.723 0 0 0-2.974-9.486 15.518 15.518 0 0 0-8.048-5.76M34.26 27.63a3.101 3.101 0 0 0-1.024-.657 3.08 3.08 0 0 0-2.358 0c-.381.15-.73.372-1.024.657l-9.31 9.383a3.153 3.153 0 0 0-.912 2.22c0 .833.328 1.632.913 2.221.584.589 1.376.92 2.203.92.826 0 1.619-.331 2.203-.92l4.003-4.066v17.483c0 .83.326 1.625.909 2.212a3.09 3.09 0 0 0 2.194.916 3.09 3.09 0 0 0 2.194-.916 3.14 3.14 0 0 0 .908-2.212V37.39l4.003 4.066a3.1 3.1 0 0 0 2.203.925 3.081 3.081 0 0 0 2.204-.925 3.129 3.129 0 0 0 .917-2.22 3.15 3.15 0 0 0-.917-2.221z"
        }
      ) }) }),
      /* @__PURE__ */ h("defs", { children: [
        /* @__PURE__ */ a("clipPath", { id: "a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h64v64H0z" }) }),
        /* @__PURE__ */ a("clipPath", { id: "b", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 1h64v64H0z" }) })
      ] })
    ]
  }
), N = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M3 9a1 1 0 0 0 1-1V5a1 1 0 0 1 1-1h3a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v3a1 1 0 0 0 1 1m5 11H5a1 1 0 0 1-1-1v-3a1 1 0 1 0-2 0v3a3 3 0 0 0 3 3h3a1 1 0 0 0 0-2m4-12a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4m7-12h-3a1 1 0 1 0 0 2h3a1 1 0 0 1 1 1v3a1 1 0 0 0 2 0V5a3 3 0 0 0-3-3m2 13a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 0 0 2h3a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1"
      }
    )
  }
), W = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currenColor",
        d: "M19 2a1 1 0 0 0-1 1v5.46l-1 .67V3a1 1 0 0 0-2 0v6.13l-1-.67V3a1 1 0 0 0-2 0v6a1 1 0 0 0 .45.83L15 11.54V21a1 1 0 0 0 2 0v-9.46l2.55-1.71A1 1 0 0 0 20 9V3a1 1 0 0 0-1-1M9 2a5 5 0 0 0-5 5v6a1 1 0 0 0 1 1h3v7a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1M8 12H6V7a3 3 0 0 1 2-2.83z"
      }
    )
  }
), U = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M16.84 11.63a2.998 2.998 0 0 0 2.16-.88l2.83-2.83a1 1 0 1 0-1.42-1.41l-2.86 2.82a1 1 0 0 1-1.42 0l3.54-3.53a1.004 1.004 0 0 0-1.42-1.42l-3.53 3.54a1 1 0 0 1 0-1.41l2.83-2.83a1.004 1.004 0 0 0-1.42-1.42L13.3 5.09a3 3 0 0 0 0 4.24L12 10.62l-8.27-8.3-.1-.06a.71.71 0 0 0-.17-.11l-.18-.07L3.16 2h-.27a.57.57 0 0 0-.18 0 .7.7 0 0 0-.17.09l-.16.1h-.07l-.06.1a1 1 0 0 0-.11.17 1.07 1.07 0 0 0-.07.19v.11a11 11 0 0 0 3.11 9.34l2.64 2.63-5.41 5.4a1 1 0 0 0 .71 1.71 1 1 0 0 0 .71-.29l6.07-5.98 2.83-2.83 2-2a3 3 0 0 0 2.11.89m-7.65 1.82-2.63-2.64A9.06 9.06 0 0 1 4 5.4l6.61 6.6zm6.24.57A1.008 1.008 0 0 0 14 15.44l6.3 6.3a1 1 0 0 0 .7.26 1 1 0 0 0 .71-1.71z"
      }
    )
  }
), y = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M12.217 2.024a1 1 0 0 0-.434 0l-9 2A1 1 0 0 0 2 5v17h2v-8c2 0 4-4 4-6h8c0 2 2 6 4 6v8h2V5a1 1 0 0 0-.783-.976z" })
  }
), G = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M8 20H4v-4h4zm0-6H4v-4h4zm0-6H4V4h4zm6 12h-4v-4h4zm0-6h-4v-4h4zm0-6h-4V4h4zm6 12h-4v-4h4zm0-6h-4v-4h4zm0-6h-4V4h4z" })
  }
), T = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M7 16a1.5 1.5 0 0 0 1.5-1.5.77.77 0 0 0 0-.15l2.79-2.79h.46l1.61 1.61v.08a1.5 1.5 0 1 0 3 0v-.08L20 9.5A1.5 1.5 0 1 0 18.5 8a.767.767 0 0 0 0 .15l-3.61 3.61h-.16L13 10a1.5 1.5 0 1 0-3 0l-3 3a1.5 1.5 0 1 0 0 3m13.5 4h-17V3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2"
      }
    )
  }
), E = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M12 7a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1m.92 8.62a.758.758 0 0 0-.09-.18l-.12-.15a.999.999 0 0 0-1.09-.21 1.15 1.15 0 0 0-.33.21A1 1 0 0 0 11 16c.002.13.029.26.08.38a.9.9 0 0 0 .54.54.94.94 0 0 0 .76 0 .9.9 0 0 0 .54-.54c.051-.12.078-.25.08-.38a1.362 1.362 0 0 0 0-.2.639.639 0 0 0-.08-.18M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20" })
  }
), j = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M17.34 5.46a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4m4.6 2.42a7.588 7.588 0 0 0-.46-2.43 4.94 4.94 0 0 0-1.16-1.77 4.7 4.7 0 0 0-1.77-1.15 7.3 7.3 0 0 0-2.43-.47C15.06 2 14.72 2 12 2s-3.06 0-4.12.06a7.3 7.3 0 0 0-2.43.47 4.78 4.78 0 0 0-1.77 1.15 4.7 4.7 0 0 0-1.15 1.77 7.3 7.3 0 0 0-.47 2.43C2 8.94 2 9.28 2 12s0 3.06.06 4.12a7.3 7.3 0 0 0 .47 2.43 4.7 4.7 0 0 0 1.15 1.77 4.78 4.78 0 0 0 1.77 1.15 7.3 7.3 0 0 0 2.43.47C8.94 22 9.28 22 12 22s3.06 0 4.12-.06a7.3 7.3 0 0 0 2.43-.47 4.7 4.7 0 0 0 1.77-1.15 4.85 4.85 0 0 0 1.16-1.77c.285-.78.44-1.6.46-2.43 0-1.06.06-1.4.06-4.12s0-3.06-.06-4.12M20.14 16a5.61 5.61 0 0 1-.34 1.86 3.06 3.06 0 0 1-.75 1.15c-.324.33-.717.586-1.15.75a5.61 5.61 0 0 1-1.86.34c-1 .05-1.37.06-4 .06s-3 0-4-.06a5.73 5.73 0 0 1-1.94-.3 3.27 3.27 0 0 1-1.1-.75 3 3 0 0 1-.74-1.15 5.54 5.54 0 0 1-.4-1.9c0-1-.06-1.37-.06-4s0-3 .06-4a5.54 5.54 0 0 1 .35-1.9A3 3 0 0 1 5 5a3.14 3.14 0 0 1 1.1-.8A5.73 5.73 0 0 1 8 3.86c1 0 1.37-.06 4-.06s3 0 4 .06a5.61 5.61 0 0 1 1.86.34 3.06 3.06 0 0 1 1.19.8c.328.307.584.683.75 1.1.222.609.337 1.252.34 1.9.05 1 .06 1.37.06 4s-.01 3-.06 4M12 6.87A5.13 5.13 0 1 0 17.14 12 5.12 5.12 0 0 0 12 6.87m0 8.46a3.33 3.33 0 1 1 0-6.66 3.33 3.33 0 0 1 0 6.66" })
  }
), q = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M17.811 5.23A7.45 7.45 0 0 0 12.505 3c-1.99 0-3.9.802-5.307 2.23A7.67 7.67 0 0 0 5 10.614c0 2.019.79 3.955 2.198 5.383l4.661 4.738a.884.884 0 0 0 .628.265.874.874 0 0 0 .628-.265l4.696-4.783A7.638 7.638 0 0 0 20 10.592c0-2.012-.787-3.94-2.189-5.362m-1.265 9.44-4.041 4.118-4.042-4.119A5.823 5.823 0 0 1 6.9 11.701a5.874 5.874 0 0 1 .326-3.348 5.78 5.78 0 0 1 2.104-2.6 5.655 5.655 0 0 1 3.174-.977c1.13 0 2.234.34 3.173.977a5.779 5.779 0 0 1 2.105 2.6 5.874 5.874 0 0 1 .326 3.348 5.823 5.823 0 0 1-1.563 2.968M9.851 7.858a3.905 3.905 0 0 0-1.115 2.737c0 1.025.401 2.01 1.115 2.736.53.54 1.206.907 1.942 1.058a3.76 3.76 0 0 0 2.195-.209 3.823 3.823 0 0 0 1.713-1.407c.422-.63.652-1.372.66-2.134a3.853 3.853 0 0 0-.284-1.482 3.808 3.808 0 0 0-.83-1.254 3.801 3.801 0 0 0-1.23-.853 3.756 3.756 0 0 0-4.166.808m4.148 4.2a2.038 2.038 0 0 1-2.604.277 2.088 2.088 0 0 1-.833-1.13 2.12 2.12 0 0 1 .063-1.41 2.08 2.08 0 0 1 .932-1.047c.42-.23.907-.303 1.376-.209.468.095.89.351 1.192.726.303.375.468.845.467 1.33a2.104 2.104 0 0 1-.637 1.462z" })
  }
), D = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "m12.59 13-2.3 2.29a1.002 1.002 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l4-4a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33l-4-4a1.003 1.003 0 1 0-1.42 1.42l2.3 2.29H3a1 1 0 0 0 0 2zM12 2a10 10 0 0 0-9 5.55 1.006 1.006 0 1 0 1.8.9A8 8 0 1 1 12 20a7.929 7.929 0 0 1-7.16-4.45 1.006 1.006 0 0 0-1.8.9A10 10 0 1 0 12 2" })
  }
), K = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "m21.32 5.05-6-2h-.07a.701.701 0 0 0-.14 0h-.43L9 5 3.32 3.05a1 1 0 0 0-.9.14A1 1 0 0 0 2 4v14a1 1 0 0 0 .68.95l6 2c.201.066.419.066.62 0l5.7-1.9L20.68 21c.106.015.214.015.32 0a.94.94 0 0 0 .58-.19A1.002 1.002 0 0 0 22 20V6a1 1 0 0 0-.68-.95M8 18.61l-4-1.33V5.39l4 1.33zm6-1.33-4 1.33V6.72l4-1.33zm6 1.33-4-1.33V5.39l4 1.33z" })
  }
), J = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M19 11H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2" })
  }
), O = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M12 12a3 3 0 1 0 0 5.999A3 3 0 0 0 12 12m0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-.71-6.29a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21L15 7.46A1.032 1.032 0 1 0 13.54 6l-.54.59V3a1 1 0 0 0-2 0v3.59L10.46 6A1.032 1.032 0 1 0 9 7.46zM19 15a1 1 0 1 0-2 0 1 1 0 0 0 2 0m1-7h-3a1 1 0 1 0 0 2h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h3a1 1 0 0 0 0-2H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3M5 15a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
      }
    )
  }
), Q = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M19 3H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h6v2H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2h-4v-2h6a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3m1 11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z"
      }
    )
  }
), X = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ h("g", { fill: "currentColor", clipPath: "url(#a)", children: [
        /* @__PURE__ */ a("path", { d: "M3.62 17.28a1 1 0 1 0 1.86-.74l-1.12-2.82L11 12.25V17a1 1 0 0 0 2 0v-4.75l6.64 1.47-1.12 2.82a1 1 0 1 0 1.86.74l1.55-3.91a1 1 0 0 0-.05-.84 1 1 0 0 0-.66-.51L18 11.31V7a1 1 0 0 0-1-1h-2V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3H7a1 1 0 0 0-1 1v4.31L2.78 12a1 1 0 0 0-.66.51 1 1 0 0 0-.05.84zM11 4h2v2h-2zM8 8h8v2.86L12.22 10H11.78L8 10.86zm12.71 11.28a4.38 4.38 0 0 0-1 .45 2.08 2.08 0 0 1-2.1 0 4.62 4.62 0 0 0-4.54 0 2.14 2.14 0 0 1-2.12 0 4.64 4.64 0 0 0-4.54 0 2.08 2.08 0 0 1-2.1 0 4.38 4.38 0 0 0-1-.45A1 1 0 0 0 2 20a1 1 0 0 0 .67 1.24 2.1 2.1 0 0 1 .57.25 4 4 0 0 0 2 .55 4.14 4.14 0 0 0 2.08-.56 2.65 2.65 0 0 1 2.56 0 4.15 4.15 0 0 0 4.12 0 2.65 2.65 0 0 1 2.56 0 4 4 0 0 0 4.1 0 2.1 2.1 0 0 1 .57-.25A1 1 0 0 0 22 20a1 1 0 0 0-1.29-.72" }),
        /* @__PURE__ */ a(
          "path",
          {
            stroke: "#fff",
            strokeWidth: 2,
            d: "M-.021 21.192 21.192-.02l2.828 2.828L2.807 24.021z"
          }
        )
      ] }),
      /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
), Y = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ h("g", { fill: "currentColor", clipPath: "url(#a)", children: [
        /* @__PURE__ */ a(
          "path",
          {
            fillRule: "evenodd",
            d: "M11.417 2.354a1.832 1.832 0 0 1 2.166 0l5.41 3.982h.062v.046l1.558 1.147a.829.829 0 0 1 .171 1.175.866.866 0 0 1-1.197.168l-.532-.392v11.842h2.09c.472 0 .855.375.855.839 0 .463-.383.839-.855.839H3.855A.847.847 0 0 1 3 21.16c0-.463.383-.838.855-.838h2.09V8.48l-.532.392a.866.866 0 0 1-1.197-.168.829.829 0 0 1 .171-1.175l1.558-1.147v-.046h.063zM7.655 20.322h1.14v-.187h-1.14zm0-1.865v-1.119h1.14v1.119zm1.14-2.797v-1.12h-1.14v1.12zm-1.14-2.797v-1.12h1.14v1.12zm1.14-2.798a.87.87 0 0 1 .248.036 1.81 1.81 0 0 1 1.557-.875h3.8a1.81 1.81 0 0 1 1.557.875.87.87 0 0 1 .248-.036h1.14V8.947h-9.69v1.118zm7.41 2.798v-1.12h1.14v1.12zm0 1.678v1.119h1.14v-1.12zm0 3.916v-1.119h1.14v1.119zm0 1.678v.187h1.14v-.187zM7.655 7.268h9.69v-.047l-1.554-1.143a.866.866 0 0 1-.346.071h-5.89a.866.866 0 0 1-.346-.071L7.655 7.22zm3.736-2.797h2.218l-1.052-.774a.096.096 0 0 0-.114 0zm3.104 15.85v-9.323a.094.094 0 0 0-.095-.093h-3.8a.094.094 0 0 0-.095.093v9.324z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ a(
          "path",
          {
            stroke: "#fff",
            strokeWidth: 2,
            d: "M-.021 21.192 21.192-.02l2.828 2.828L2.807 24.021z"
          }
        )
      ] }),
      /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
), Z = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ h("g", { fill: "currentColor", clipPath: "url(#a)", children: [
        /* @__PURE__ */ a("path", { d: "M12.217 2.024a1 1 0 0 0-.434 0l-9 2A1 1 0 0 0 2 5v17h2v-8c2 0 4-4 4-6h8c0 2 2 6 4 6v8h2V5a1 1 0 0 0-.783-.976z" }),
        /* @__PURE__ */ a(
          "path",
          {
            stroke: "#fff",
            strokeWidth: 2,
            d: "M-.021 21.192 21.192-.02l2.828 2.828L2.807 24.021z"
          }
        )
      ] }),
      /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
), _ = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ h("g", { fill: "currentColor", clipPath: "url(#a)", children: [
        /* @__PURE__ */ a("path", { d: "M12 6H9a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0v-3h2a4 4 0 1 0 0-8m0 6h-2V8h2a2 2 0 0 1 0 4m7-10H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z" }),
        /* @__PURE__ */ a(
          "path",
          {
            stroke: "#fff",
            strokeWidth: 2,
            d: "M-.021 21.192 21.192-.02l2.828 2.828L2.807 24.021z"
          }
        )
      ] }),
      /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
), $ = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ h("g", { fill: "currentColor", clipPath: "url(#a)", children: [
        /* @__PURE__ */ a("path", { d: "M12 2a10 10 0 0 0-8.4 4.59 10 10 0 0 0 14.66 13.2A10 10 0 0 0 12 2m2 2.26A8 8 0 0 1 19.74 10 9.78 9.78 0 0 0 15 11.38a15.7 15.7 0 0 0-2.4-2.21A10.06 10.06 0 0 0 14 4.26M12 4a7.9 7.9 0 0 1-1.14 4.07c-.15-.08-.29-.17-.44-.24a15.52 15.52 0 0 0-4.09-1.47A8 8 0 0 1 12 4M5 8.16A13.75 13.75 0 0 1 9.49 9.6l.13.08A7.93 7.93 0 0 1 4 12a8 8 0 0 1 1-3.84m5 11.58A8 8 0 0 1 4.26 14a9.9 9.9 0 0 0 7.08-3.21 14 14 0 0 1 2 1.8A10 10 0 0 0 10 19.74m2 .26a8.002 8.002 0 0 1 2.56-5.85c.06.08.12.15.17.23a14 14 0 0 1 1.84 4.18A7.93 7.93 0 0 1 12 20m6.21-3a16.001 16.001 0 0 0-1.8-3.75L16.2 13a7.93 7.93 0 0 1 3.8-1 8 8 0 0 1-1.79 5" }),
        /* @__PURE__ */ a(
          "path",
          {
            stroke: "#fff",
            strokeWidth: 2,
            d: "M-.021 21.192 21.192-.02l2.828 2.828L2.807 24.021z"
          }
        )
      ] }),
      /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
), a0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M10.94 6.08A6.93 6.93 0 0 1 12 6c3.18 0 6.17 2.29 7.91 6a15.213 15.213 0 0 1-.9 1.64 1 1 0 0 0 .05 1.152 1 1 0 0 0 1.65-.102 15.75 15.75 0 0 0 1.21-2.3.999.999 0 0 0 0-.79C19.9 6.91 16.1 4 12 4a7.77 7.77 0 0 0-1.4.12 1.015 1.015 0 0 0 .34 2zM3.71 2.29a1.004 1.004 0 1 0-1.42 1.42l3.1 3.09a14.62 14.62 0 0 0-3.31 4.8 1 1 0 0 0 0 .8C4.1 17.09 7.9 20 12 20a9.26 9.26 0 0 0 5.05-1.54l3.24 3.25a.998.998 0 0 0 1.42 0 .997.997 0 0 0 .219-1.095.998.998 0 0 0-.22-.325zm6.36 9.19 2.45 2.45a2 2 0 0 1-2.45-2.45M12 18c-3.18 0-6.17-2.29-7.9-6a12.09 12.09 0 0 1 2.7-3.79L8.57 10A4 4 0 0 0 14 15.43L15.59 17A7.239 7.239 0 0 1 12 18" })
  }
), l0 = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ h("g", { fill: "currentColor", clipPath: "url(#a)", children: [
        /* @__PURE__ */ a(
          "path",
          {
            fillRule: "evenodd",
            d: "M2.293 7.793a1 1 0 0 1 1.414 0L7.414 11.5H19a1 1 0 0 1 .832.445l2 3a1 1 0 0 1-1.664 1.11L18.465 13.5H7.535l-1.703 2.555a1 1 0 0 1-1.664-1.11l1.545-2.318-3.42-3.42a1 1 0 0 1 0-1.414",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ a(
          "path",
          {
            stroke: "#fff",
            strokeWidth: 2,
            d: "M-.021 21.192 21.192-.02l2.828 2.828L2.807 24.021z"
          }
        )
      ] }),
      /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
), h0 = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ h("g", { fill: "currentColor", clipPath: "url(#a)", children: [
        /* @__PURE__ */ a("path", { d: "M7.707 6.543a1 1 0 0 0-1.414 1.414l3.42 3.42-.915 1.373H7.414L3.707 9.043a1 1 0 0 0-1.414 1.414l3.42 3.42-1.545 2.318a1 1 0 0 0 1.664 1.11l1.703-2.555h.599a1 1 0 0 0 1.698.055l.037-.055h4.596l1.703 2.555a1 1 0 0 0 1.664-1.11l-2-3A1 1 0 0 0 15 12.75h-3.798l.333-.5h6.93l1.703 2.555a1 1 0 0 0 1.664-1.11l-2-3A1 1 0 0 0 19 10.25h-7.586z" }),
        /* @__PURE__ */ a(
          "path",
          {
            stroke: "#fff",
            strokeWidth: 2,
            d: "M-.021 21.192 21.192-.02l2.828 2.828L2.807 24.021z"
          }
        )
      ] }),
      /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
), o0 = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ h("g", { fill: "currentColor", clipPath: "url(#a)", children: [
        /* @__PURE__ */ a(
          "path",
          {
            fillRule: "evenodd",
            d: "M6.634 4.706a1 1 0 1 1 1.732-1l.028.048a9 9 0 0 1 11.4 3.746 1 1 0 0 1-.366 1.366l-6.062 3.5 4 6.928c.015.026.029.053.041.08a2.795 2.795 0 0 1 1.05-.271c1.013-.046 2.01.428 2.725 1.397.435.588.829.63 1.082.587.343-.058.607-.3.68-.45l1.616.795c-.339.687-1.104 1.28-1.996 1.43-.982.166-2.03-.21-2.83-1.292-.393-.533-.838-.685-1.195-.67-.372.018-.757.22-1.021.609-.413.608-1.24 1.22-2.163 1.356-1.012.15-2.146-.174-3.055-1.25-.863-1.021-2.166-.855-2.79-.09-.359.647-1.094 1.193-1.946 1.337-.982.166-2.03-.21-2.83-1.292-.393-.533-.838-.685-1.195-.67-.378.018-.77.227-1.035.629L1 20.54c.56-.852 1.465-1.394 2.458-1.438 1.012-.046 2.008.428 2.724 1.397.435.588.829.63 1.082.587.343-.058.607-.3.68-.45l.088-.143c1.276-1.7 3.99-1.998 5.643-.04.503.596 1.016.69 1.416.63.396-.058.687-.264.818-.411l.033-.049a.996.996 0 0 1-.308-.33l-4-6.928-6.062 3.5a1 1 0 0 1-1.366-.366A9 9 0 0 1 6.662 4.754zM8.5 5.938a7 7 0 0 0-3 8.66l12-6.928a7 7 0 0 0-9-1.732",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ a(
          "path",
          {
            stroke: "#fff",
            strokeWidth: 2,
            d: "M-.021 21.192 21.192-.02l2.828 2.828L2.807 24.021z"
          }
        )
      ] }),
      /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
), t0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M12 6H9a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0v-3h2a4 4 0 1 0 0-8m0 6h-2V8h2a2 2 0 0 1 0 4m7-10H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z" })
  }
), n0 = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none",
    viewBox: "0 0 96 96",
    ...l,
    children: [
      /* @__PURE__ */ a("circle", { cx: 48, cy: 48, r: 46, stroke: "currentColor", strokeWidth: 4 }),
      /* @__PURE__ */ a("g", { clipPath: "url(#a)", children: /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          d: "M62.4 74.667A41.12 41.12 0 0 1 21.333 33.6 12.267 12.267 0 0 1 33.6 21.333a10.51 10.51 0 0 1 2.053.187 10.11 10.11 0 0 1 1.92.48 2.667 2.667 0 0 1 1.734 2l3.653 16a2.667 2.667 0 0 1-.693 2.453c-.347.374-.374.4-3.654 2.107A26.427 26.427 0 0 0 51.6 57.6c1.733-3.307 1.76-3.333 2.133-3.68a2.668 2.668 0 0 1 2.454-.693l16 3.653a2.666 2.666 0 0 1 1.92 1.733c.225.633.394 1.285.506 1.947.108.67.161 1.348.16 2.027A12.267 12.267 0 0 1 62.4 74.667"
        }
      ) }),
      /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M16 16h64v64H16z" }) }) })
    ]
  }
), c0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M19.44 13c-.22 0-.45-.07-.67-.12a9.443 9.443 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.45a12.18 12.18 0 0 1-2.66-2 12.18 12.18 0 0 1-2-2.66l.42-.28a2 2 0 0 0 1-2.48 10.32 10.32 0 0 1-.39-1.31c-.05-.22-.09-.45-.12-.68a3 3 0 0 0-3-2.49h-3a3 3 0 0 0-3 3.41 19 19 0 0 0 16.52 16.46h.38a3 3 0 0 0 2.741-1.778 3 3 0 0 0 .259-1.232v-3a3 3 0 0 0-2.47-2.9m.5 6a1 1 0 0 1-.723.962 1.05 1.05 0 0 1-.437.038A17 17 0 0 1 4.07 5.22a1.09 1.09 0 0 1 .25-.82 1 1 0 0 1 .75-.34h3a1 1 0 0 1 1 .79c.04.273.09.543.15.81.116.527.27 1.045.46 1.55l-1.4.65a1 1 0 0 0-.49 1.33 14.49 14.49 0 0 0 7 7 1 1 0 0 0 .76 0 1.002 1.002 0 0 0 .57-.52l.62-1.4c.517.185 1.045.338 1.58.46.267.06.537.11.81.15a1 1 0 0 1 .79 1z"
      }
    )
  }
), i0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14c.165-.002.328-.019.49-.05l.3-.07H19.91l.37-.14.13-.07c.1-.06.21-.11.31-.18a3.78 3.78 0 0 0 .38-.32l.07-.09c.098-.1.188-.206.27-.32l.09-.13c.07-.111.13-.228.18-.35.027-.048.05-.098.07-.15.05-.12.08-.25.12-.38v-.15c.057-.195.09-.397.1-.6V5a3 3 0 0 0-3-3M5 20a1 1 0 0 1-1-1v-4.31l3.29-3.3a1 1 0 0 1 1.42 0l8.6 8.61zm15-1a1 1 0 0 1-.07.36c-.023.049-.05.096-.08.14a.948.948 0 0 1-.09.12l-5.35-5.35.88-.88a1.002 1.002 0 0 1 1.42 0l3.29 3.3zm0-5.14L18.12 12a3.08 3.08 0 0 0-4.24 0l-.88.88L10.12 10a3.08 3.08 0 0 0-4.24 0L4 11.86V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z" })
  }
), e0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "m20.71 16.1-1.64-1.64a.94.94 0 0 1-.22-1.07 5.78 5.78 0 0 0 .54-2.39.356.356 0 0 0 0-.1 5.74 5.74 0 0 0-1.06-3.34 14.17 14.17 0 0 0-5.17-4.42 7 7 0 0 0-8 1.31l-.67.67a7 7 0 0 0-1.31 8.05l.1.17a3 3 0 0 0-.84 2.06A3 3 0 0 0 7 17.94c.18.14.34.29.52.42.379.263.788.478 1.22.64h.09c.18.07.37.13.57.19h.15c.311.08.63.13.95.15h.62c.21 0 .41 0 .62-.06h.17c.492-.085.97-.236 1.42-.45a1 1 0 0 1 1.07.21l1.46 1.46a3.4 3.4 0 0 0 2.39 1 2.85 2.85 0 0 0 2-.85l.38-.38a3 3 0 0 0 .08-4.17m-15.3.32a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3.1.14-.26-.2a2.94 2.94 0 0 0 .16-.94 3 3 0 0 0-3-3h-.38l-.09-.16a5 5 0 0 1 .93-5.75l.67-.67A5 5 0 0 1 12.28 5a12 12 0 0 1 4.26 3.57zm10.78 2.37-.37.38c-.42.42-1.07.34-1.61-.2l-1.46-1.45a3 3 0 0 0-3.34-.61c-.315.154-.653.259-1 .31a2.836 2.836 0 0 1-.58.05H10.49l6.87-6.87a3.8 3.8 0 0 1-.34 2 3 3 0 0 0 .61 3.34l1.64 1.65a1 1 0 0 1 .02 1.4" })
  }
), r0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M19 11h-6V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2" })
  }
), v0 = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ...l,
    children: [
      /* @__PURE__ */ a("g", { clipPath: "url(#a)", children: /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          d: "M32.276 11.813V3.627c0-.708.29-1.386.808-1.886.517-.5 1.219-.781 1.95-.781.732 0 1.434.28 1.951.781.517.5.808 1.178.808 1.886v8.186c0 .707-.29 1.386-.808 1.886-.517.5-1.219.781-1.95.781a2.808 2.808 0 0 1-1.951-.781 2.623 2.623 0 0 1-.808-1.886m19.31 9.307c.363.002.723-.065 1.06-.198.335-.133.641-.328.899-.575l6.041-5.787c.514-.5.802-1.176.802-1.88s-.288-1.38-.802-1.88a2.808 2.808 0 0 0-1.945-.776c-.728 0-1.428.28-1.944.776l-5.987 5.787a2.64 2.64 0 0 0-.738 1.357 2.585 2.585 0 0 0 .157 1.525c.206.483.553.896 1 1.19.447.293.972.454 1.512.461zM16.47 48.693l-5.986 5.787a2.663 2.663 0 0 0-.604.868 2.59 2.59 0 0 0 0 2.05 2.763 2.763 0 0 0 1.502 1.451 2.84 2.84 0 0 0 2.121.001c.336-.135.641-.333.898-.583l5.986-5.787c.257-.249.461-.544.6-.869a2.6 2.6 0 0 0 0-2.049 2.673 2.673 0 0 0-.6-.869 2.778 2.778 0 0 0-.898-.58 2.853 2.853 0 0 0-2.12 0 2.777 2.777 0 0 0-.899.58m-2.18-14.026c0-.708-.29-1.386-.807-1.886A2.808 2.808 0 0 0 11.53 32H3.09c-.732 0-1.434.28-1.951.781a2.622 2.622 0 0 0-.808 1.886c0 .707.29 1.385.808 1.885.517.5 1.219.781 1.95.781h8.442c.732 0 1.433-.28 1.95-.78.518-.5.809-1.18.809-1.886m0-23.734a2.837 2.837 0 0 0-1.747-.364 2.798 2.798 0 0 0-1.612.75c-.436.415-.717.96-.798 1.546a2.592 2.592 0 0 0 .35 1.695l5.987 5.787c.258.247.563.442.9.575.336.133.695.2 1.059.198.363.002.723-.065 1.059-.198.336-.133.641-.328.9-.575.513-.5.801-1.176.801-1.88 0-.705-.288-1.38-.802-1.88zM62.76 62.4a2.808 2.808 0 0 1-1.945.775 2.808 2.808 0 0 1-1.945-.775l-10.014-9.68-7.117 8.933a2.741 2.741 0 0 1-.965.765c-.378.18-.793.274-1.214.275h-.47a2.8 2.8 0 0 1-1.337-.616c-.379-.32-.66-.734-.814-1.197L27.255 31.2a2.581 2.581 0 0 1-.058-1.447c.118-.478.372-.915.731-1.262.36-.348.812-.593 1.307-.708a2.849 2.849 0 0 1 1.496.057l30.538 9.493a2.77 2.77 0 0 1 1.251.784c.335.367.559.816.647 1.298.088.482.038.978-.146 1.434A2.677 2.677 0 0 1 62.124 42l-9.241 6.88 9.986 9.653c.505.499.788 1.169.788 1.867s-.283 1.368-.788 1.867zM46.51 46.933l.193-.16.194-.16 7.558-5.626-20.441-6.32L40.552 54.4z"
        }
      ) }),
      /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h64v64H0z" }) }) })
    ]
  }
), w0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M20.18 10.19c-.72-.13-1.45-.194-2.18-.19-.42 0-.83 0-1.24.08a5.91 5.91 0 0 0-1.91-1.65 3.81 3.81 0 0 0 1-2.57 3.86 3.86 0 0 0-7.72 0 3.81 3.81 0 0 0 1 2.57 6.11 6.11 0 0 0-1.91 1.64C6.83 10 6.42 10 6 10c-.732.003-1.461.073-2.18.21a1 1 0 0 0-.82 1v8.25a1 1 0 0 0 .745.971 1 1 0 0 0 .435.019A9.752 9.752 0 0 1 6 20.23a9.89 9.89 0 0 1 5.45 1.63l.13.05c.133.058.275.088.42.09a.871.871 0 0 0 .28-.05h.07l.13-.05A9.89 9.89 0 0 1 18 20.23c.61.003 1.22.063 1.82.18a1 1 0 0 0 .82-.22 1 1 0 0 0 .36-.77v-8.25a1 1 0 0 0-.82-.98M12 4a1.86 1.86 0 0 1 0 3.71A1.86 1.86 0 0 1 12 4m-1 15.33a11.92 11.92 0 0 0-5-1.1c-.33 0-.66 0-1 .05V12a9.63 9.63 0 0 1 2.52.05h.11A10 10 0 0 1 11 13.33zm1-7.73a11.773 11.773 0 0 0-1.38-.68h-.06c-.33-.13-.66-.26-1-.36A4 4 0 0 1 12 9.69a4 4 0 0 1 2.44.85A12.43 12.43 0 0 0 12 11.6m7 6.68a11.6 11.6 0 0 0-6 1v-6a9.761 9.761 0 0 1 3.37-1.22h.2A9.389 9.389 0 0 1 19 12z"
      }
    )
  }
), s0 = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ...l,
    children: [
      /* @__PURE__ */ a("g", { clipPath: "url(#a)", children: /* @__PURE__ */ a("g", { clipPath: "url(#b)", children: /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          d: "M54.936 7.617a2.906 2.906 0 0 0-1.142-.547 2.95 2.95 0 0 0-1.273-.013 23.596 23.596 0 0 1-9.319.023A23.32 23.32 0 0 1 34.64 3.5 2.928 2.928 0 0 0 33 3c-.586 0-1.157.174-1.639.5a23.32 23.32 0 0 1-8.563 3.58 23.596 23.596 0 0 1-9.32-.023 2.95 2.95 0 0 0-1.272.013 2.906 2.906 0 0 0-1.142.547 2.813 2.813 0 0 0-.787.975A2.74 2.74 0 0 0 10 9.802v20.866a24.683 24.683 0 0 0 2.865 11.545A25.41 25.41 0 0 0 20.84 51.2l10.494 7.282c.486.337 1.07.519 1.667.519.598 0 1.18-.181 1.667-.52L45.162 51.2a25.41 25.41 0 0 0 7.974-8.986A24.683 24.683 0 0 0 56 30.668V9.802a2.741 2.741 0 0 0-.277-1.21 2.813 2.813 0 0 0-.787-.975M50.25 30.668c.002 3.122-.761 6.2-2.226 8.977a19.762 19.762 0 0 1-6.198 6.988L33 52.767l-8.826-6.134a19.762 19.762 0 0 1-6.198-6.988 19.198 19.198 0 0 1-2.226-8.977V13.023A29.363 29.363 0 0 0 33 9.129a29.363 29.363 0 0 0 17.25 3.894zm-12.822-6.414-7.734 7.562-2.559-2.52a2.926 2.926 0 0 0-2.041-.824c-.766 0-1.5.296-2.042.824a2.776 2.776 0 0 0-.845 1.988c0 .746.304 1.462.845 1.989l4.6 4.481c.268.263.586.471.936.613a2.94 2.94 0 0 0 2.211 0c.35-.142.669-.35.936-.613l9.89-9.55a2.776 2.776 0 0 0 .846-1.99c0-.745-.305-1.46-.846-1.988a2.926 2.926 0 0 0-2.041-.824c-.766 0-1.5.297-2.042.824z"
        }
      ) }) }),
      /* @__PURE__ */ h("defs", { children: [
        /* @__PURE__ */ a("clipPath", { id: "a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h64v64H0z" }) }),
        /* @__PURE__ */ a("clipPath", { id: "b", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h64v64H0z" }) })
      ] })
    ]
  }
), g0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M20 8.18V3a1 1 0 0 0-2 0v5.18a3 3 0 0 0 0 5.64V21a1 1 0 0 0 2 0v-7.18a3 3 0 0 0 0-5.64M19 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-6 2.18V3a1 1 0 0 0-2 0v11.18a3 3 0 0 0 0 5.64V21a1 1 0 0 0 2 0v-1.18a3 3 0 0 0 0-5.64M12 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2M6 6.18V3a1 1 0 0 0-2 0v3.18a3 3 0 0 0 0 5.64V21a1 1 0 1 0 2 0v-9.18a3 3 0 0 0 0-5.64M5 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2" })
  }
), d0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M12.92 15a.561.561 0 0 0-.09-.17l-.12-.15a1 1 0 0 0-1.54.15.561.561 0 0 0-.09.17.699.699 0 0 0-.06.19 1.23 1.23 0 0 0 0 .19.88.88 0 0 0 .08.39 1 1 0 0 0 1.3.54c.121-.054.233-.129.33-.22.09-.092.161-.2.21-.32.053-.123.08-.256.08-.39a1.23 1.23 0 0 0 0-.19.702.702 0 0 0-.1-.19M12 7.36a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1m7.63-3.71a1 1 0 0 0-.84-.2 8 8 0 0 1-6.22-1.27 1 1 0 0 0-1.14 0 8 8 0 0 1-6.22 1.27A1 1 0 0 0 4 4.43v7.45a9 9 0 0 0 3.77 7.33l3.65 2.6a1 1 0 0 0 1.16 0l3.65-2.6A9 9 0 0 0 20 11.88V4.43a1 1 0 0 0-.37-.78M18 11.88a7 7 0 0 1-2.93 5.7L12 19.77l-3.07-2.19A7 7 0 0 1 6 11.88v-6.3a10 10 0 0 0 6-1.39 10 10 0 0 0 6 1.39z"
      }
    )
  }
), p0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M22 2H2a1 1 0 0 0-1 1v4a3 3 0 0 0 2 2.82V21a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9.82A3 3 0 0 0 23 7V3a1 1 0 0 0-1-1m-7 2h2v3a1 1 0 0 1-2 0zm-4 0h2v3a1 1 0 0 1-2 0zM7 4h2v3a1 1 0 0 1-2 0zM4 8a1 1 0 0 1-1-1V4h2v3a1 1 0 0 1-1 1m10 12h-4v-4a2 2 0 0 1 4 0zm5 0h-3v-4a4 4 0 1 0-8 0v4H5V9.82a3.17 3.17 0 0 0 1-.6 3 3 0 0 0 4 0 3 3 0 0 0 4 0 3 3 0 0 0 4 0c.293.26.632.464 1 .6zm2-13a1 1 0 0 1-2 0V4h2z" })
  }
), m0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M14 18a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1m-4 0a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1m9-12h-1.38l-1.73-3.45a.999.999 0 0 0-1.915.515 1 1 0 0 0 .135.385L15.38 6H8.62l1.27-2.55a1 1 0 0 0-1.78-.9L6.38 6H5a3 3 0 0 0-.92 5.84l.74 7.46a3 3 0 0 0 3 2.7h8.38a3 3 0 0 0 3-2.7l.74-7.46A3 3 0 0 0 19 6m-1.81 13.1a1 1 0 0 1-1 .9H7.81a1 1 0 0 1-1-.9L6.1 12h11.8zM19 10H5a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2"
      }
    )
  }
), f0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M22 15h-2v-3a1 1 0 0 0-1-1h-6V9h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2v2H5a1 1 0 0 0-1 1v3H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H6v-2h12v2h-2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1M7 17v4H3v-4zm3-10V3h4v4zm11 14h-4v-4h4z"
      }
    )
  }
), M0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M22 9.67a1 1 0 0 0-.86-.67l-5.69-.83L12.9 3a1 1 0 0 0-1.8 0L8.55 8.16 2.86 9a1 1 0 0 0-.81.68 1 1 0 0 0 .25 1l4.13 4-1 5.68a1 1 0 0 0 1.45 1.07L12 18.76l5.1 2.68c.14.08.299.12.46.12a1 1 0 0 0 .59-.19 1 1 0 0 0 .4-1l-1-5.68 4.13-4A1 1 0 0 0 22 9.67m-6.15 4a1.001 1.001 0 0 0-.29.89l.72 4.19-3.76-2a1 1 0 0 0-.94 0l-3.76 2 .72-4.19a1 1 0 0 0-.29-.89l-3-3 4.21-.61a1 1 0 0 0 .76-.55L12 5.7l1.88 3.82a1 1 0 0 0 .76.55l4.21.61z" })
  }
), x0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M11.58 16.5h-1.26l.86-1.5a1 1 0 1 0-1.73-1l-1.73 3a1 1 0 0 0 .86 1.5h1.27L9 20a1.003 1.003 0 1 0 1.74 1l1.73-3a1 1 0 0 0-.89-1.5m9.42-9h-.8a4.25 4.25 0 0 0-.52-1.27l.56-.56a1 1 0 0 0-1.41-1.41l-.56.56A4.25 4.25 0 0 0 17 4.3v-.8a1 1 0 0 0-2 0v.8a4.25 4.25 0 0 0-1.27.52l-.56-.56a1 1 0 0 0-1.41 1.41l.56.57c-.09.15-.16.32-.24.48a5.85 5.85 0 0 0-1.58-.22 6 6 0 0 0-5.94 5.13 3.49 3.49 0 0 0-.34 6.62 1.002 1.002 0 0 0 1.428-.945 1 1 0 0 0-.708-.915 1.5 1.5 0 0 1 .56-2.89 1 1 0 0 0 1-1 4 4 0 0 1 7.78-1.29 1 1 0 0 0 .78.67 2.33 2.33 0 0 1 .25 4.53 1.01 1.01 0 0 0 .27 2c.09.015.18.015.27 0a4.298 4.298 0 0 0 2.85-5.72l.13.13a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41l-.56-.56a4.25 4.25 0 0 0 .52-1.35h.8a1 1 0 1 0 0-2m-3.34 2.65a2.28 2.28 0 0 1-.6.41A4.17 4.17 0 0 0 16 10a6.12 6.12 0 0 0-2.09-2.49 2.42 2.42 0 0 1 .46-.7 2.43 2.43 0 0 1 3.3 0 2.37 2.37 0 0 1 0 3.3z"
      }
    )
  }
), I0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fillRule: "evenodd",
        d: "M6.634 4.706a1 1 0 1 1 1.732-1l.028.048a9 9 0 0 1 11.4 3.746 1 1 0 0 1-.366 1.366l-6.062 3.5 4 6.928c.015.026.029.053.041.08a2.795 2.795 0 0 1 1.05-.271c1.013-.046 2.01.428 2.725 1.397.435.588.829.63 1.082.587.343-.058.607-.3.68-.45l1.616.795c-.339.687-1.104 1.28-1.996 1.43-.982.166-2.03-.21-2.83-1.292-.393-.533-.838-.685-1.195-.67-.372.018-.757.22-1.021.609-.413.608-1.24 1.22-2.163 1.356-1.012.15-2.146-.174-3.055-1.25-.863-1.021-2.166-.855-2.79-.09-.359.647-1.094 1.193-1.946 1.337-.982.166-2.03-.21-2.83-1.292-.393-.533-.838-.685-1.195-.67-.378.018-.77.227-1.035.629L1 20.54c.56-.852 1.465-1.394 2.458-1.438 1.012-.046 2.008.428 2.724 1.397.435.588.829.63 1.082.587.343-.058.607-.3.68-.45l.088-.143c1.276-1.7 3.99-1.998 5.643-.04.503.596 1.016.69 1.416.63.396-.058.687-.264.818-.411l.033-.049a.996.996 0 0 1-.308-.33l-4-6.928-6.062 3.5a1 1 0 0 1-1.366-.366A9 9 0 0 1 6.662 4.754zM8.5 5.938a7 7 0 0 0-3 8.66l12-6.928a7 7 0 0 0-9-1.732",
        clipRule: "evenodd"
      }
    )
  }
), z0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M2.436 7.264a.9.9 0 1 0-1.272 1.272L6.027 13.4l-2.863 2.864a.9.9 0 1 0 1.272 1.272L7.8 14.173h11l3.364 3.363a.9.9 0 1 0 1.272-1.272l-2.09-2.091H23.9a.9.9 0 0 0 0-1.8H7.546z" })
  }
), u0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M7.707 6.543a1 1 0 0 0-1.414 1.414l3.42 3.42-.915 1.373H7.414L3.707 9.043a1 1 0 0 0-1.414 1.414l3.42 3.42-1.545 2.318a1 1 0 0 0 1.664 1.11l1.703-2.555h.599a1 1 0 0 0 1.698.055l.037-.055h4.596l1.703 2.555a1 1 0 0 0 1.664-1.11l-2-3A1 1 0 0 0 15 12.75h-3.798l.333-.5h6.93l1.703 2.555a1 1 0 0 0 1.664-1.11l-2-3A1 1 0 0 0 19 10.25h-7.586z" })
  }
), A0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M12 3A10 10 0 0 0 2 13v7a1 1 0 0 0 1 1h3a3 3 0 0 0 3-3v-2a3 3 0 0 0-3-3H4a8 8 0 0 1 16 0h-2a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h3a1 1 0 0 0 1-1v-7A10 10 0 0 0 12 3M6 15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4v-4zm14 4h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2z" })
  }
), C0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M17 9.28a2 2 0 1 0 0-4 2 2 0 0 0 0 4M2.71 13.92c.198.063.39.147.57.25a4.06 4.06 0 0 0 4.1 0 2.62 2.62 0 0 1 2.56 0l.21.1a4.14 4.14 0 0 0 3.87-.13 2.62 2.62 0 0 1 2.56 0 4.25 4.25 0 0 0 2.08.56 4 4 0 0 0 2-.56c.18-.103.372-.187.57-.25a.999.999 0 1 0-.52-1.89 4.821 4.821 0 0 0-1 .44 2.1 2.1 0 0 1-2.1 0 4.62 4.62 0 0 0-4.54 0 2.51 2.51 0 0 1-.29.12L14.34 11a.743.743 0 0 0 .09-.15.995.995 0 0 0 .12-.16 1.282 1.282 0 0 0 0-.19 1.058 1.058 0 0 0 0-.19c.005-.06.005-.12 0-.18a1.057 1.057 0 0 0 0-.19 1.511 1.511 0 0 0-.1-.17.698.698 0 0 0-.1-.16l-3.07-3.33a1.1 1.1 0 0 0-.28-.22.8.8 0 0 0-.21 0 .53.53 0 0 0-.17 0A.89.89 0 0 0 10.2 6L6.66 7.32a1 1 0 0 0 .68 1.88l2.93-1.07 2 2.12-1.9 1.9a4.621 4.621 0 0 0-3.94.28 2.1 2.1 0 0 1-2.1 0 4.82 4.82 0 0 0-1-.44 1 1 0 1 0-.58 1.91zm18 3.09a4.821 4.821 0 0 0-1 .44 2.1 2.1 0 0 1-2.1 0 4.62 4.62 0 0 0-4.54 0 2.11 2.11 0 0 1-2.12 0 4.62 4.62 0 0 0-4.54 0 2.1 2.1 0 0 1-2.1 0 4.82 4.82 0 0 0-1-.44 1 1 0 1 0-.58 1.91c.198.063.39.147.57.25a4.06 4.06 0 0 0 4.1 0 2.62 2.62 0 0 1 2.56 0 4.15 4.15 0 0 0 4.12 0 2.62 2.62 0 0 1 2.56 0 4.25 4.25 0 0 0 2.08.56 4 4 0 0 0 2-.56c.18-.103.372-.187.57-.25a1.003 1.003 0 1 0-.58-1.92z"
      }
    )
  }
), H0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M11.5 20h-6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v5a1 1 0 0 0 2 0V8.94a1.307 1.307 0 0 0-.06-.27v-.09a1.07 1.07 0 0 0-.19-.28l-6-6a1.071 1.071 0 0 0-.28-.19.29.29 0 0 0-.1 0 1.099 1.099 0 0 0-.31-.11H5.5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h6a1 1 0 0 0 0-2m1-14.59L15.09 8H13.5a1 1 0 0 1-1-1zM7.5 14h6a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2m4 2h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m-4-6h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2m13.71 6.29a1.002 1.002 0 0 0-1.42 0l-3.29 3.3-1.29-1.3a1.004 1.004 0 0 0-1.42 1.42l2 2a1.002 1.002 0 0 0 1.42 0l4-4a1.002 1.002 0 0 0 0-1.42"
      }
    )
  }
), S0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M22 10.94a1.306 1.306 0 0 0-.06-.27v-.09a1.071 1.071 0 0 0-.19-.28l-6-6a1.071 1.071 0 0 0-.28-.19h-.1a1.099 1.099 0 0 0-.31-.11H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6zm-6-3.53L18.59 10H17a1 1 0 0 1-1-1zM20 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h9v3a3 3 0 0 0 3 3h3zM7 12h4a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2m0 2a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2z"
      }
    )
  }
), V0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M9 10a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m12 1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1 1 1 0 0 1 0 2 1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1 1 1 0 0 1 0-2m-1-1.82a3 3 0 0 0 0 5.64V17H10a1 1 0 1 0-2 0H4v-2.18a3 3 0 0 0 0-5.64V7h4a1 1 0 0 0 2 0h10z" })
  }
), B0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M11 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-14a1 1 0 0 0-1 1v4.42l-2.1 1.21a1 1 0 0 0 .5 1.87 1 1 0 0 0 .5-.13l2.6-1.5.09-.09.16-.13a.863.863 0 0 0 .1-.16.891.891 0 0 0 .08-.17.65.65 0 0 0 .05-.2L12 12V7a1 1 0 0 0-1-1" })
  }
), L0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M22 5.8a8.49 8.49 0 0 1-2.36.64 4.13 4.13 0 0 0 1.81-2.27 8.21 8.21 0 0 1-2.61 1 4.1 4.1 0 0 0-7 3.74 11.64 11.64 0 0 1-8.45-4.29 4.16 4.16 0 0 0-.55 2.07 4.09 4.09 0 0 0 1.82 3.41 4.05 4.05 0 0 1-1.86-.51v.05a4.1 4.1 0 0 0 3.3 4 3.933 3.933 0 0 1-1.1.17 4.907 4.907 0 0 1-.77-.07 4.11 4.11 0 0 0 3.83 2.84A8.22 8.22 0 0 1 2 18.28a11.57 11.57 0 0 0 6.29 1.85A11.589 11.589 0 0 0 20 8.45v-.53a8.43 8.43 0 0 0 2-2.12" })
  }
), P0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M15.71 12.71a6 6 0 1 0-7.42 0 10 10 0 0 0-6.22 8.18 1.006 1.006 0 1 0 2 .22 8 8 0 0 1 15.9 0 1 1 0 0 0 1 .89h.11a1 1 0 0 0 .88-1.1 10 10 0 0 0-6.25-8.19M12 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
      }
    )
  }
), k0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M13.3 12.22A4.92 4.92 0 0 0 15 8.5a5 5 0 0 0-10 0 4.92 4.92 0 0 0 1.7 3.72A8 8 0 0 0 2 19.5a1 1 0 1 0 2 0 6 6 0 1 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.7-7.28M10 11.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6m11.71-2.37a1 1 0 0 0-1.42 0l-2 2-.62-.63a1.002 1.002 0 0 0-1.71.705 1 1 0 0 0 .29.705l1.34 1.34a1 1 0 0 0 1.41 0l2.67-2.67a1 1 0 0 0 .04-1.45"
      }
    )
  }
), b0 = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ a("path", { d: "M12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6" }),
      /* @__PURE__ */ a(
        "path",
        {
          fillRule: "evenodd",
          d: "M18.487 19.611A9.978 9.978 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.978 9.978 0 0 0 3.513 7.611A9.96 9.96 0 0 0 12 22c2.475 0 4.74-.9 6.487-2.389m-.657-2.267A7.592 7.592 0 0 0 20 12a8 8 0 1 0-13.875 5.43C7.168 15.402 9.406 14 12 14c2.557 0 4.769 1.363 5.83 3.344",
          clipRule: "evenodd"
        }
      )
    ]
  }
), R0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M14.81 12.28a3.73 3.73 0 0 0 1-2.5 3.78 3.78 0 1 0-7.56 0 3.73 3.73 0 0 0 1 2.5A5.94 5.94 0 0 0 6 16.89a1.006 1.006 0 1 0 2 .22 4 4 0 0 1 7.94 0A1 1 0 0 0 17 18h.11a1 1 0 0 0 .88-1.1 5.94 5.94 0 0 0-3.18-4.62M12 11.56A1.78 1.78 0 1 1 12 8a1.78 1.78 0 0 1 0 3.56M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z"
      }
    )
  }
), F0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M12 2a10 10 0 0 0-7.35 16.76 10.001 10.001 0 0 0 14.7 0A9.999 9.999 0 0 0 12 2m0 18a8 8 0 0 1-5.55-2.25 6 6 0 0 1 11.1 0A8 8 0 0 1 12 20m-2-10a2 2 0 1 1 4 0 2 2 0 0 1-4 0m8.91 6A8 8 0 0 0 15 12.62a4 4 0 1 0-6 0A8 8 0 0 0 5.09 16 7.92 7.92 0 0 1 4 12a8 8 0 1 1 16 0 7.92 7.92 0 0 1-1.09 4" })
  }
), N0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M12.3 12.22A4.92 4.92 0 0 0 14 8.5a5 5 0 0 0-10 0 4.92 4.92 0 0 0 1.7 3.72A8 8 0 0 0 1 19.5a1 1 0 1 0 2 0 6 6 0 1 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.7-7.28M9 11.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6m9.74.32A5 5 0 0 0 15 3.5a1 1 0 1 0 0 2 3 3 0 0 1 3 3 3 3 0 0 1-1.5 2.59 1 1 0 0 0-.05 1.7l.39.26.13.07a7 7 0 0 1 4 6.38 1 1 0 0 0 2 0 9 9 0 0 0-4.23-7.68" })
  }
), W0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M8 2H3a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V4h4a1 1 0 0 0 0-2m0 18H4v-4a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2M21 2h-5a1 1 0 1 0 0 2h4v4a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1m0 13a1 1 0 0 0-1 1v4h-4a1 1 0 0 0 0 2h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1"
      }
    )
  }
), U0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        d: "M2.72 7.65c.196.058.384.138.56.24a4 4 0 0 0 4.1 0 2.6 2.6 0 0 1 2.56 0 4.15 4.15 0 0 0 4.12 0 2.6 2.6 0 0 1 2.56 0 4.25 4.25 0 0 0 2.08.56 3.88 3.88 0 0 0 2-.56c.176-.102.364-.182.56-.24a1 1 0 1 0-.56-1.92 4.45 4.45 0 0 0-1 .45 2.08 2.08 0 0 1-2.1 0 4.64 4.64 0 0 0-4.54 0 2.11 2.11 0 0 1-2.12 0 4.64 4.64 0 0 0-4.54 0 2.08 2.08 0 0 1-2.1 0 4.45 4.45 0 0 0-1-.45 1 1 0 1 0-.56 1.92zm18 8.08c-.35.108-.686.26-1 .45a2.08 2.08 0 0 1-2.1 0 4.64 4.64 0 0 0-4.54 0 2.11 2.11 0 0 1-2.12 0 4.64 4.64 0 0 0-4.54 0 2.08 2.08 0 0 1-2.1 0 4.448 4.448 0 0 0-1-.45 1 1 0 0 0-.56 1.92c.196.058.384.138.56.24a4 4 0 0 0 4.1 0 2.6 2.6 0 0 1 2.56 0 4.15 4.15 0 0 0 4.12 0 2.6 2.6 0 0 1 2.56 0 4.25 4.25 0 0 0 2.08.56 3.88 3.88 0 0 0 2-.56c.176-.102.364-.183.56-.24a1 1 0 0 0-.56-1.92zm0-5c-.35.108-.686.26-1 .45a2.08 2.08 0 0 1-2.1 0 4.64 4.64 0 0 0-4.54 0 2.11 2.11 0 0 1-2.12 0 4.64 4.64 0 0 0-4.54 0 2.08 2.08 0 0 1-2.1 0 4.448 4.448 0 0 0-1-.45 1 1 0 0 0-1.32.68 1 1 0 0 0 .68 1.24c.196.057.384.138.56.24a4 4 0 0 0 4.1 0 2.6 2.6 0 0 1 2.56 0 4.15 4.15 0 0 0 4.12 0 2.6 2.6 0 0 1 2.56 0 4.25 4.25 0 0 0 2.08.56 3.88 3.88 0 0 0 2-.56c.176-.102.364-.183.56-.24a1 1 0 0 0-.56-1.92z"
      }
    )
  }
), y0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M12 6.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m7.5 14h-1v-5a1 1 0 0 0-1-1h-5v-2h5a1 1 0 0 0 0-2h-5v-2a1 1 0 0 0-2 0v7a1 1 0 0 0 1 1h5v5a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2m-6.8-1.6a4 4 0 0 1-7.2-2.4 4 4 0 0 1 2.4-3.66A1.003 1.003 0 0 0 7.1 11a5.999 5.999 0 1 0 7.2 9.1 1 1 0 0 0-1.6-1.2" })
  }
);
export {
  t as AlertIcon,
  n as AnimalIcon,
  c as ApproveCircleIcon,
  i as ApproveIcon,
  e as ArrowLeftIcon,
  r as ArrowRightIcon,
  v as BabyIcon,
  w as BarIcon,
  s as BarsIcon,
  g as BasketBallIcon,
  d as BoatIcon,
  p as BuildingIcon,
  m as CabinIcon,
  f as CalendarIcon,
  M as CallIcon,
  x as CanoeIcon,
  I as CashRegisterIcon,
  z as ChatInfoIcon,
  u as ChevronDownIcon,
  A as ChevronLeftIcon,
  C as ChevronRightIcon,
  H as CloseIcon,
  S as CreditCardIcon,
  V as EditIcon,
  B as EuroCoinIcon,
  L as ExternalLinkIcon,
  P as EyeIcon,
  k as FacebookIcon,
  b as Facile,
  R as FaqIcon,
  F as Flexible,
  N as FocusIcon,
  W as ForkIcon,
  U as ForkKnifeIcon,
  y as GazeboIcon,
  G as GridIcon,
  T as GrowthGraphIcon,
  E as InfoIcon,
  j as InstagramIcon,
  q as LocationIcon,
  D as LogoutIcon,
  K as MapIcon,
  J as MinusIcon,
  O as MoneyWithdrawalIcon,
  Q as MonitorIcon,
  X as NoBoatIcon,
  Y as NoCabinIcon,
  Z as NoGazeboIcon,
  _ as NoParkingIcon,
  $ as NoPlayfieldIcon,
  a0 as NoPreviewIcon,
  l0 as NoSunbedIcon,
  h0 as NoSunbedsIcon,
  o0 as NoUmbrellaIcon,
  t0 as ParkingIcon,
  n0 as PhoneCircle,
  c0 as PhoneIcon,
  i0 as PictureIcon,
  e0 as PingPongIcon,
  r0 as PlusIcon,
  v0 as Rapide,
  w0 as ReaderIcon,
  s0 as Security,
  g0 as SettingIcon,
  d0 as ShieldInfoIcon,
  p0 as ShopIcon,
  m0 as ShoppingBasketIcon,
  f0 as SitemapIcon,
  M0 as StarIcon,
  x0 as StormWeatherIcon,
  I0 as SunUmbrellaIcon,
  z0 as SunbedIcon,
  u0 as SunbedsIcon,
  A0 as SupportIcon,
  C0 as SwimmerIcon,
  H0 as TextFileApproveIcon,
  S0 as TextFileLandscapeIcon,
  V0 as TicketIcon,
  B0 as TimeClock,
  L0 as TwitterIcon,
  P0 as UserAccountIcon,
  k0 as UserApproveIcon,
  b0 as UserIcon,
  R0 as UserPictureIcon,
  F0 as UserProfileIcon,
  N0 as UsersIcon,
  W0 as ViewAllIcon,
  U0 as WaterIcon,
  y0 as WheelChairIcon
};
